import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-chart',
	templateUrl:'./WaChartProPage.html',
	styles: [],
	styleUrls:['./WaChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaChartProPage
{
	mdContent_306 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaChart;
\`\`\``;
	mdContent_307 = `\`\`\`java
var chart = new WaBarChart<>();
chart.setLabel("Monthly Revenue");
chart.setXAxisLabel("Month");
chart.setYAxisLabel("Revenue ($)");
chart.setLegendPosition(LegendPosition.Bottom);
\`\`\``;
}
